import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { Paper } from 'shared/ui/paper'

import { RouteItem } from './components/RouteItem'
import s from './styles.module.scss'

interface OrderRoute {
  departureTime: string
  departureDate: string
  departureCity: string
  departureAddress: string

  arrivalTime: string
  arrivalDate: string
  arrivalCity: string
  arrivalAddress: string
}

interface Props {
  orderInfo: OrderRoute | null
}

export const MyOrderRoute = ({ orderInfo }: Props) => {
  const { t } = useTranslation()

  if (!orderInfo) return null

  return (
    <Paper padding={[16]}>
      <div className={s.container}>
        <p className={clsx(s.title, 'semi-bold-17')}>{t('route')}</p>

        <div className={s.box}>
          <AppIcon
            id={AllIcons.PATH}
            className={s.icon}
            width={8}
            height={58}
          />

          <div className={s.flex}>
            <div className={s.info}>
              <RouteItem
                title={orderInfo.departureTime}
                subtitle={orderInfo.departureDate}
              />
              <RouteItem
                title={orderInfo.departureCity}
                subtitle={orderInfo.departureAddress}
              />
            </div>

            <div className={s.info}>
              <RouteItem
                title={orderInfo.arrivalTime}
                subtitle={orderInfo.arrivalDate}
              />
              <RouteItem
                title={orderInfo.arrivalCity}
                subtitle={orderInfo.arrivalAddress}
              />
            </div>
          </div>
        </div>
      </div>
    </Paper>
  )
}
